export default __webpack_public_path__ + "static/media/door.9ebc587f.mp3";